<template>
  <div class="primary--text">
    <v-row no-gutters>
      <v-col cols="12" class="caption font-weight-bold">
        {{ $t("agarre_exterior") | capitalize }}
        <v-tooltip right max-width="400px">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="primary">mdi-information</v-icon>
          </template>
          <span>Material que constituirá la unión entre el material de revestimiento seleccionado y la superficie
            de colocación.</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="agarre.posibles"
                                  v-model="solucionConstructiva.agarre" :cargando="agarre.cargando"
                                  @change="cambiaAgarre"/>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="caption font-weight-bold">
        {{ $t("separacion_exterior") | capitalize }}
        <v-tooltip right max-width="400px">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="primary">mdi-information</v-icon>
          </template>
          <span>Tiene como misión evitar el contacto directo entre dos capas contiguas o evitar el paso de materiales
            de una capa a otra. Puede hacer también las funciones de barrera de vapor.</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="caption pa-2"
             v-if="(solucionConstructiva.procesoConstructivo == null) && !separacion.cargando">
          {{ $t("proceso_constructivo_antes") | capitalize }}
        </div>
        <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="separacion.posibles"
                                  v-if="separacion.cargando || (escenario.tipoSoporteExterior != null)"
                                  v-model="solucionConstructiva.separacion" :cargando="separacion.cargando"
                                  @change="cambiaSeparacion"/>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="caption font-weight-bold">
        {{ $t("regularizacion_exterior") | capitalize }}
        <v-tooltip right max-width="400px">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="primary">mdi-information</v-icon>
          </template>
          <span>Capa intermedia que permite corregir la desviación de la planitud de la superficie de colocación y que
            tiene como objetivo conseguir un cambio de cota, ejecutar una pendiente, etc.</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="caption pa-2" v-if="(escenario.pavExistExterior == null) && !regularizacion.cargando">
          {{ $t("escenario_antes") | capitalize }}
        </div>
        <div class="caption pa-2"
             v-if="(solucionConstructiva.procesoConstructivo == null) && !regularizacion.cargando">
          {{ $t("proceso_constructivo_antes") | capitalize }}
        </div>

        <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="regularizacion.posibles"
                                  v-if="regularizacion.cargando || solucionConstructiva.agarre != null"
                                  v-model="solucionConstructiva.regularizacion" :cargando="regularizacion.cargando"
                                  @change="cambiaRegularizacion"/>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="caption font-weight-bold">
        {{ $t("impermeabilizacion_exterior") | capitalize }}
        <v-tooltip right max-width="400px">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="primary">mdi-information</v-icon>
          </template>
          <span>Capa intermedia que permite corregir la desviación de la planitud de la superficie de colocación y que
            tiene como objetivo conseguir un cambio de cota, ejecutar una pendiente, etc.</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="caption pa-2" v-if="(escenario.pavExistExterior == null || escenario.tipoSoporteExterior == null) && !impermeabilizacion.cargando">
          {{ $t("escenario_antes") | capitalize }}
        </div>
        <div class="caption pa-2"
             v-if="(solucionConstructiva.procesoConstructivo == null) && !impermeabilizacion.cargando">
          {{ $t("proceso_constructivo_antes") | capitalize }}
        </div>
        <div class="caption pa-2"
             v-if="(solucionConstructiva.agarre == null) && !impermeabilizacion.cargando">
          {{ $t("agarre_antes") | capitalize }}
        </div>
        <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="impermeabilizacion.posibles"
                                  v-if="impermeabilizacion.cargando || (escenario.pavExistExterior != null && escenario.tipoSoporteExterior != null && solucionConstructiva.procesoConstructivo != null && solucionConstructiva.agarre != null)"
                                  v-model="solucionConstructiva.impermeabilizacion"
                                  :cargando="impermeabilizacion.cargando"
                                  @change="cambiaImpermeabilizacion"/>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="caption font-weight-bold">
        {{ $t("proceso_constructivo_exterior") | capitalize }}
        <v-tooltip right max-width="400px">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="primary">mdi-information</v-icon>
          </template>
          <span>La herramienta contemplará unas operaciones de rehabilitación u otras en función de la opción seleccionada.</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="procesoConstructivo.posibles"
                                  v-model="solucionConstructiva.procesoConstructivo"
                                  :cargando="procesoConstructivo.cargando"
                                  @change="cambiaProcesoConstructivo"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import SeleccionComponenteSC from "../../Componentes/SeleccionComponenteSC";

export default {
  name: "ComponentesExteriorR",
  components: {
    SeleccionComponenteSC
  },
  model: {
    prop: 'correcto',
    event: 'change'
  },
  props: {
    escenario: {type: Object, required: true},
    solucionConstructiva: {type: Object, required: true},
    correcto: {type: Boolean, default: false},
  },
  data: function () {
    return {
      agarre: {
        cargando: false,
        posibles: [],
        codigos: []
      },
      regularizacion: {
        cargando: false,
        posibles: [],
        codigos: []
      },
      impermeabilizacion: {
        cargando: false,
        posibles: [],
        codigos: []
      },
      separacion: {
        cargando: false,
        posibles: [],
        codigos: []
      },
      procesoConstructivo: {
        cargando: false,
        posibles: [],
        codigos: []
      }
    }
  },
  mounted() {
    Promise.all([
      this.cargarAgarres(),
      this.cargarRegularizaciones(),
      this.cargarImpermeabilizaciones(),
      this.cargarSeparaciones(),
      this.cargarProcesosConstructivos()
    ])
        .then(() => {
          this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
        });
  },
  watch: {
    escenario: {
      handler() {
        Promise.all([
          this.cargarRegularizaciones(),
          this.cargarRegularizaciones(),
          this.cargarImpermeabilizaciones(),
        ]).then(() => {
          this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
        });
      },
      deep: true
    },
    solucionConstructiva: {
      handler() {
        this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
      },
      deep: true
    }
  },
  methods: {
    emitirCorrecto(value) {
      this.$emit('change', value);
    },
    cargarAgarres() {
      const url = `exterior/agarre-rehabilitacion`;
      this.agarre.posibles = [];
      this.agarre.codigos = [];

      return new Promise((resolve) => {
        const anterior = this.solucionConstructiva.agarre;

        this.agarre.cargando = true;
        const params = {
          dermis: this.solucionConstructiva.materialDermis.codigo
        };
        HttpHelper.get(url, params)
            .then(data => {
              this.agarre.posibles = data;
              data.forEach((type) => this.agarre.codigos.push(type.codigo));
              this.solucionConstructiva.agarre = null;
              if (anterior != null && this.agarre.codigos.includes(anterior.codigo))
                this.solucionConstructiva.agarre = anterior;

              resolve();
            })
            .finally(() => this.agarre.cargando = false);
      });
    },
    cargarRegularizaciones() {
      const url = `exterior/regularizacion-rehabilitacion`;
      this.regularizacion.posibles = [];
      this.regularizacion.codigos = [];

      return new Promise((resolve) => {
        if ((!this.escenario && !this.escenario.pavExistExterior)
            || !this.solucionConstructiva.procesoConstructivo) {
          resolve();
          return;
        }

        const anterior = this.solucionConstructiva.regularizacion;

        this.regularizacion.cargando = true;
        const params = {
          pavimentoExistente: this.escenario.pavExistExterior.codigo,
          dermis: this.solucionConstructiva.materialDermis.codigo,
          procesoConstructivo: this.solucionConstructiva.procesoConstructivo.codigo,
        };
        HttpHelper.get(url, params)
            .then(data => {
              this.regularizacion.posibles = data;
              data.forEach((type) => this.regularizacion.codigos.push(type.codigo));
              this.solucionConstructiva.regularizacion = null;
              if (anterior != null && this.regularizacion.codigos.includes(anterior.codigo))
                this.solucionConstructiva.regularizacion = anterior;

              resolve();
            })
            .finally(() => this.regularizacion.cargando = false);
      });
    },
    cargarImpermeabilizaciones() {
      const url = `exterior/impermeabilizacion-rehabilitacion`;
      this.impermeabilizacion.posibles = [];
      this.impermeabilizacion.codigos = [];

      return new Promise((resolve) => {
        if (!this.escenario || !this.escenario.pavExistExterior || !this.escenario.tipoSoporteExterior
            || !this.solucionConstructiva.procesoConstructivo || !this.solucionConstructiva.agarre) {
          resolve();
          return;
        }

        const anterior = this.solucionConstructiva.impermeabilizacion;

        this.impermeabilizacion.cargando = true;
        const params = {
          pavimentoExistente: this.escenario.pavExistExterior.codigo,
          dermis: this.solucionConstructiva.materialDermis.codigo,
          procesoConstructivo: this.solucionConstructiva.procesoConstructivo.codigo,
          agarre: this.solucionConstructiva.agarre.codigo,
          tipoSoporte: this.escenario.tipoSoporteExterior.codigo
        };
        HttpHelper.get(url, params)
            .then(data => {
              this.impermeabilizacion.posibles = data;
              data.forEach((type) => this.impermeabilizacion.codigos.push(type.codigo));
              this.solucionConstructiva.impermeabilizacion = null;
              if (anterior != null && this.impermeabilizacion.codigos.includes(anterior.codigo))
                this.solucionConstructiva.impermeabilizacion = anterior;

              resolve();
            })
            .finally(() => this.impermeabilizacion.cargando = false);
      });
    },
    cargarSeparaciones() {
      const url = `exterior/separacion-rehabilitacion`;
      this.separacion.posibles = [];
      this.separacion.codigos = [];

      return new Promise((resolve) => {
        if (!this.solucionConstructiva.procesoConstructivo) {
          resolve();
          return;
        }
        const anterior = this.solucionConstructiva.separacion;

        const params = {
          procesoConstructivo: this.solucionConstructiva.procesoConstructivo.codigo,
          dermis: this.solucionConstructiva.materialDermis.codigo
        };
        this.separacion.cargando = true;
        HttpHelper.get(url, params)
            .then(data => {
              this.separacion.posibles = data;
              data.forEach((type) => this.separacion.codigos.push(type.codigo));
              this.solucionConstructiva.separacion = null;
              if (anterior != null && this.separacion.codigos.includes(anterior.codigo))
                this.solucionConstructiva.separacion = anterior;

              resolve();
            })
            .finally(() => this.separacion.cargando = false);
      });
    },
    cargarProcesosConstructivos() {
      const url = `exterior/proceso-constructivo`;
      this.procesoConstructivo.posibles = [];
      this.procesoConstructivo.codigos = [];

      return new Promise((resolve) => {
        const anterior = this.solucionConstructiva.procesoConstructivo;

        this.procesoConstructivo.cargando = true;
        HttpHelper.get(url)
            .then(data => {
              this.procesoConstructivo.posibles = data;
              data.forEach((type) => this.procesoConstructivo.codigos.push(type.codigo));
              this.solucionConstructiva.procesoConstructivo = null;
              if (anterior != null && this.procesoConstructivo.codigos.includes(anterior.codigo))
                this.solucionConstructiva.procesoConstructivo = anterior;

              resolve();
            })
            .finally(() => this.procesoConstructivo.cargando = false);
      });
    },
    cambiaAgarre: function (item) {
      if (!this.agarre.codigos.includes(item.codigo)) this.solucionConstructiva.agarre = null;
      this.cargarImpermeabilizaciones();
    },
    cambiaRegularizacion: function (item) {
      if (!this.regularizacion.codigos.includes(item.codigo)) this.solucionConstructiva.regularizacion = null;
    },
    cambiaImpermeabilizacion: function (item) {
      if (!this.impermeabilizacion.codigos.includes(item.codigo)) this.solucionConstructiva.impermeabilizacion = null;
    },
    cambiaSeparacion: function (item) {
      if (!this.separacion.codigos.includes(item.codigo)) this.solucionConstructiva.separacion = null;
    },
    cambiaProcesoConstructivo: function (item) {
      if (!this.procesoConstructivo.codigos.includes(item.codigo)) this.procesoConstructivo.soporte = null;
      this.cargarSeparaciones();
      this.cargarRegularizaciones();
      this.cargarImpermeabilizaciones();
    },
    solucionConstructivaEsCorrecta(solucionConstructiva) {
      if (solucionConstructiva.agarre == null ||
          !this.agarre.codigos.includes(solucionConstructiva.agarre.codigo)) return false;

      if (solucionConstructiva.regularizacion == null ||
          !this.regularizacion.codigos.includes(solucionConstructiva.regularizacion.codigo)) return false;

      if (solucionConstructiva.impermeabilizacion == null ||
          !this.impermeabilizacion.codigos.includes(solucionConstructiva.impermeabilizacion.codigo)) return false;

      if (solucionConstructiva.separacion == null ||
          !this.separacion.codigos.includes(solucionConstructiva.separacion.codigo)) return false;

      if (solucionConstructiva.procesoConstructivo == null ||
          !this.procesoConstructivo.codigos.includes(solucionConstructiva.procesoConstructivo.codigo)) return false;

      return true;
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "agarre_exterior": "Agarre",
    "regularizacion_exterior": "Regularización",
    "impermeabilizacion_exterior": "Impermeabilización",
    "separacion_exterior": "Separación",
    "soporte_base_exterior": "Soporte base",
    "proceso_constructivo_exterior": "Proceso constructivo",
    "soporte_helada_escenario_antes": "Debes seleccionar el tipo de soporte y riesgo de helada del escenario antes",
    "escenario_antes": "Debes seleccionar el escenario antes",
    "agarre_antes": "Debes seleccionar el agarre antes",
    "proceso_constructivo_antes": "Debes seleccionar el proceso constructivo antes",
    "soporte_escenario_antes": "Debes seleccionar el tipo de soporte del escenario antes",
    "no_aplica": "No aplica"
  }
}
</i18n>
<!--@formatter:on-->